import React from 'react'
import DurationDisplay from 'support/displays/Duration'
import { Column } from '@morningtrain/react-columns'

function Duration (props) {
  return <Column {...props} display={DurationDisplay} />
}

Duration.propTypes = {
  ...Column.propTypes
}

export default Duration
